module.exports = __webpack_public_path__ + "img/jiaotongguangbo.f8d4c9e6.jpg";